import {createAction} from "@reduxjs/toolkit";

export const setParentInfopage = createAction('SET_PARENT_INFOPAGE');